import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const LikeNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="url(#LikeNotification1)" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.123 7.117a.525.525 0 0 1 .478-.309c.514 0 1.008.201 1.374.561.366.36.574.851.574 1.364v1.342h2.156a1.487 1.487 0 0 1 1.122.498 1.455 1.455 0 0 1 .348 1.18v.001l-.655 4.2c-.054.35-.234.666-.505.893-.27.226-.613.348-.964.345H8.28c-.387 0-.761-.152-1.038-.425a1.45 1.45 0 0 1-.435-1.034v-3.266c0-.39.158-.762.435-1.035.277-.272.65-.424 1.039-.424h1.083l1.758-3.89Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="LikeNotification1"
        x1={12}
        y1={-3.5}
        x2={12}
        y2={26.5}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#00CCE8" />
        <Stop offset="1" stopColor="#4FACFE" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default LikeNotification;
